const BASE_API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5180/api';

const EXT_SCHEME: Record<string, string> = {
  doc: 'ms-word', docx: 'ms-word',
  xls: 'ms-excel', xlsx: 'ms-excel', csv: 'ms-excel',
  ppt: 'ms-powerpoint', pptx: 'ms-powerpoint',
};
const SP_TYPE_SCHEME: Record<string, string> = { w: 'ms-word', x: 'ms-excel', p: 'ms-powerpoint' };

// Returns the href to put on an <a> element for Preview.
// Office files  → ms-word:ofe|u|<url>  (opens desktop app when user clicks the link directly)
// PDF / others  → original URL (opens in new browser tab)
export function getOfficeHref(rawUrl: string): string {
  if (!rawUrl) return '';
  const url = /^https?:\/\//i.test(rawUrl.trim()) ? rawUrl.trim() : `https://${rawUrl.trim()}`;

  // 1. SharePoint sharing link prefix /:w:/ /:x:/ /:p:/ /:b:/
  const spMatch = url.match(/\/:([wxpb]):/i);
  if (spMatch) {
    const scheme = SP_TYPE_SCHEME[spMatch[1].toLowerCase()];
    return scheme ? `${scheme}:ofe|u|${url}` : url;
  }

  // 2. file= query param (Doc.aspx?...&file=report.docx&...)
  try {
    const fileParam = new URL(url).searchParams.get('file');
    if (fileParam) {
      const ext = fileParam.split('.').pop()?.toLowerCase() ?? '';
      const scheme = EXT_SCHEME[ext];
      if (scheme) return `${scheme}:ofe|u|${url}`;
    }
  } catch { /* skip */ }

  // 3. Path extension
  const ext = url.split('?')[0].split('#')[0].split('.').pop()?.toLowerCase() ?? '';
  const scheme = EXT_SCHEME[ext];
  return scheme ? `${scheme}:ofe|u|${url}` : url;
}

// Keep for non-Office fallback (PDF etc.) where we just open in browser
export function openInOffice(rawUrl: string): void {
  window.open(rawUrl, '_blank', 'noopener,noreferrer');
}

function authHeaders() {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export interface DriveItem {
  id: string;
  name: string;
  webUrl: string;
  isFolder: boolean;
}

export async function listItems(folderId?: string): Promise<DriveItem[]> {
  const url = folderId
    ? `${BASE_API_URL}/SharePoint/files/${encodeURIComponent(folderId)}`
    : `${BASE_API_URL}/SharePoint/files`;

  const res = await fetch(url, { headers: authHeaders() });
  if (!res.ok) throw new Error(`Failed to load files: ${res.statusText}`);
  return res.json();
}
